

import apiClient from 'api/apiClient';
import { getAuthenticatedSession } from 'cognito/auth';

export async function listActivities ( authenticatedUser )
{
    let authenticatedSession = null;
    
    try
    {
        authenticatedSession = await getAuthenticatedSession ();
    }
    catch ( error )
    {
        throw error;
    }

    return apiClient.get ( authenticatedUser.username + "/activity", 
                { 
                    headers: { 
                        "authorization": authenticatedSession.idToken, 
                        "x-user-email": authenticatedUser.signInDetails.loginId,
                        "Content-Type": "application/json" } 
                } );
}

export async function getActivity ( authenticatedUser, activityId )
{
    let authenticatedSession = null;
    
    try
    {
        authenticatedSession = await getAuthenticatedSession ();
    }
    catch ( error )
    {
        throw error;
    }

    return apiClient.get ( authenticatedUser.username + "/activity/" + activityId, 
                { 
                    headers: { 
                        "authorization": authenticatedSession.idToken, 
                        "x-user-email": authenticatedUser.signInDetails.loginId,
                        "Content-Type": "application/json" } 
                } );
}

export async function submitActivity ( authenticatedUser, name, distance, participants )
{
    let authenticatedSession = null;
    
    try
    {
        authenticatedSession = await getAuthenticatedSession ();
    }
    catch ( error )
    {
        throw error;
    }

    let payload = {
        name: name,
        distance: distance,
        participants: participants
    };

    return apiClient.post ( authenticatedUser.username + "/activity", 
                payload,
                { 
                    headers: { 
                        "authorization": authenticatedSession.idToken, 
                        "x-user-email": authenticatedUser.signInDetails.loginId,
                        "Content-Type": "application/json" } 
                } );
}

export async function updateActivity ( authenticatedUser, activityId, name, distance, participants )
{
    let authenticatedSession = null;
    
    try
    {
        authenticatedSession = await getAuthenticatedSession ();
    }
    catch ( error )
    {
        throw error;
    }

    let payload = {
        name: name,
        distance: distance,
        participants: participants
    };

    return apiClient.put ( authenticatedUser.username + "/activity/" + activityId, 
                payload,
                { 
                    headers: { 
                        "authorization": authenticatedSession.idToken, 
                        "x-user-email": authenticatedUser.signInDetails.loginId,
                        "Content-Type": "application/json" } 
                } );
}